import React, {useEffect, useState} from 'react';
import {findUserDrafts} from "./infra/repository/FindUserDrafts";

export default () => {
  const [drafts, setDrafts] = useState('');
  
  const loadDrafts = async () => {

    try {
      console.log('loadDrafts');
      const data = await findUserDrafts();
      setDrafts(data);
    } catch (err) {
      console.log(err.message);
    }
  };

  useEffect(() => {
    loadDrafts();
  }, []); // Empty dependency array ensures this runs only once

  return (
      <>

        <section>
          <div className="drafts-header">
            <span>Your drafts</span>
          </div>
          <ul className="drafts-list">
            {drafts && drafts.map(draft => (
                <li key={draft.id}>
                  <a href={`/draft?draftId=${draft.id}`}>{draft.name}</a>
                </li>
            ))}
          </ul>
        </section>

      </>
  );
};